import styled from 'styled-components';

import { Section } from '@xing-com/layout-primitives';
import { space4XL, spaceXXL, spaceM, spaceS } from '@xing-com/tokens';

export const StyledSection = styled(Section)`
  margin-block: calc(${spaceS} + ${spaceM})
    calc(${space4XL} + ${spaceXXL} + ${spaceM});
`;
